import { render, staticRenderFns } from "./v3.vue?vue&type=template&id=1fa88ed6&scoped=true&"
import script from "./v3.vue?vue&type=script&lang=js&"
export * from "./v3.vue?vue&type=script&lang=js&"
import style0 from "./v3.vue?vue&type=style&index=0&id=1fa88ed6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa88ed6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fa88ed6')) {
      api.createRecord('1fa88ed6', component.options)
    } else {
      api.reload('1fa88ed6', component.options)
    }
    module.hot.accept("./v3.vue?vue&type=template&id=1fa88ed6&scoped=true&", function () {
      api.rerender('1fa88ed6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/agent-dashboard/v3.vue"
export default component.exports